import styles from '@/components/CheckinHistory/HistoryItem.module.css';
import { CheckinResultIcon } from '@/library/CheckinResultIcon';
import { DateTime } from '@/library/DateTime';
import { TicketCheckin } from '@/types/checkIn';
import { TICKET_CHECKIN_SUCCESS } from '@/utils/consts';

import { TableCell, TableRow } from '@mui/material';
import { memo } from 'react';

type Props = Pick<TicketCheckin, 'result' | 'ticketCode' | 'checkin'>;

const MS_PER_SECOND = 1_000;
// TicketCheckin.checkin was stored in Unix seconds before being changed to milliseconds.
// Values below 1e10 are seconds; multiply to get a valid Date.
const LEGACY_SECONDS_BOUNDARY = 1e10;
const checkinToDate = (checkin: number) =>
  new Date(checkin < LEGACY_SECONDS_BOUNDARY ? checkin * MS_PER_SECOND : checkin);

export const HistoryItem = memo((item: Props) => {
  return (
    <TableRow className={item.result === TICKET_CHECKIN_SUCCESS ? styles.success : styles.error}>
      <TableCell component="th" scope="row" padding="none">
        <CheckinResultIcon ticketCheckin={item} className={styles.icon} />
      </TableCell>
      <TableCell>{item.ticketCode}</TableCell>
      <TableCell align="right">
        <DateTime value={checkinToDate(item.checkin)} dateStyle="long" timeStyle="medium" />
      </TableCell>
    </TableRow>
  );
});
